module.exports = __webpack_public_path__ + "img/ph_qrcode_wechat.6cbe927.webp";